
export default {
    namespaced: true,
    state: {
        productData: [],
        productCurrentPeriod: 5,
        productCurrentPage: 1,
        productCountRow: 0,
        productSort:'applications',
        productSortDir:'desc',

        categoryData: [],
        categoryCurrentPeriod: 5,
        categoryCurrentPage: 1,
        categoryCountRow: 0,
        categorySort:'applications',
        categorySortDir:'desc',

        pageSize: 200,
        currentBrand: null,
    },
    getters: {
        CURRENT_BRAND: state => {
            return state.currentBrand;
        },
        PRODUCT_AMOUNT_PAGE: (state) => {
            return Math.ceil(state.productCountRow/state.pageSize);
        },
        CATEGORY_AMOUNT_PAGE: (state) => {
            return Math.ceil(state.categoryCountRow/state.pageSize);
        },
        CATEGORY_CURRENT_PERIOD: state => {
            return state.categoryCurrentPeriod;
        },
        PRODUCT_CURRENT_PERIOD: state => {
            return state.productCurrentPeriod;
        },
        PAGE_SIZE: state => {
            return state.pageSize;
        },
        PRODUCT_COUNT_ROW: state => {
            return state.productCountRow;
        },
        CATEGORY_COUNT_ROW: state => {
            return state.categoryCountRow;
        },
        PRODUCT_DATA: state => {
            return state.productData;
        },
        PRODUCT_CURRENT_PAGE: state => {
            return state.productCurrentPage;
        },
        CATEGORY_DATA: state => {
            return state.categoryData;
        },
        CATEGORY_CURRENT_PAGE: state => {
            return state.categoryCurrentPage;
        },
        PRODUCT_SORT: state => {
            return state.productSort;
        },
        PRODUCT_SORT_DIR: state => {
            return state.productSortDir;
        },
        CATEGORY_SORT: state => {
            return state.categorySort;
        },
        CATEGORY_SORT_DIR: state => {
            return state.categorySortDir;
        },
    },
    mutations: {
        CURRENT_BRAND: (state, payload) => {
            return state.currentBrand = payload;
        },
        PRODUCT_CURRENT_PERIOD: (state, payload) => {
            return state.productCurrentPeriod = payload;
        },
        CATEGORY_CURRENT_PERIOD: (state, payload) => {
            return state.categoryCurrentPeriod = payload;
        },
        PAGE_SIZE: (state, payload) => {
            return state.pageSize = payload;
        },
        CATEGORY_COUNT_ROW: (state, payload) => {
            return state.categoryCountRow = payload;
        },
        PRODUCT_COUNT_ROW: (state, payload) => {
            return state.productCountRow = payload;
        },
        PRODUCT_DATA: (state, payload) => {
            return state.productData = payload;
        },
        PRODUCT_CURRENT_PAGE: (state, payload) => {
            return state.productCurrentPage = payload;
        },
        CATEGORY_DATA: (state, payload) => {
            return state.categoryData = payload;
        },
        CATEGORY_CURRENT_PAGE: (state, payload) => {
            return state.categoryCurrentPage = payload;
        },
        PRODUCT_SORT: (state, payload) => {
            return state.productSort = payload;
        },
        PRODUCT_SORT_DIR: (state, payload) => {
            return state.productSortDir = payload;
        },
        CATEGORY_SORT: (state, payload) => {
            return state.categorySort = payload;
        },
        CATEGORY_SORT_DIR: (state, payload) => {
            return state.categorySortDir = payload;
        },
    },
    actions: {
        GET_PRODUCTS: async ({state, commit, getters}, payload) => {
            payload.th.showOverlay ++;
            var url = {string: null};
            payload.th.$store.dispatch('CREATE_PARAMS_URL', {
                params: {
                    sort: getters.PRODUCT_SORT,
                    sortDir: getters.PRODUCT_SORT_DIR,
                    page: getters.PRODUCT_CURRENT_PAGE,
                    pageSize: getters.PAGE_SIZE,
                    period: getters.PRODUCT_CURRENT_PERIOD,
                },
                url: url
            });
            // set null for rewrite vue component
            state.currentBrand = null
            payload.th.$forceUpdate()
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand/products/' + payload.id + url.string,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    // set current brand
                    state.currentBrand = responseData.brand
                    // set data
                    commit('PRODUCT_DATA', responseData.data.list);
                    commit('PRODUCT_COUNT_ROW', responseData.data.count);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_CATEGORIES: async ({commit, getters}, payload) => {
            payload.th.showOverlay ++;
            var url = {string: null};
            payload.th.$store.dispatch('CREATE_PARAMS_URL', {
                params: {
                    sort: getters.CATEGORY_SORT,
                    sortDir: getters.CATEGORY_SORT_DIR,
                    page: getters.CATEGORY_CURRENT_PAGE,
                    pageSize: getters.PAGE_SIZE,
                    period: getters.CATEGORY_CURRENT_PERIOD,
                },
                url: url
            });
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/brand/categories/' + payload.id + url.string,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('CATEGORY_DATA', responseData.data.list);
                    commit('CATEGORY_COUNT_ROW', responseData.data.count);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
    }
}